import { hugeIcons } from '@/icons/icons'

type SvgNode = [string, Record<string, string | number | boolean>]
type HugeIconDef = SvgNode[]

const isHugeIconDef = (value: unknown): value is HugeIconDef =>
  Array.isArray(value) &&
  value.every(
    (svgNode) =>
      Array.isArray(svgNode) &&
      svgNode.length === 2 &&
      typeof svgNode[0] === 'string' &&
      svgNode[1] !== null &&
      typeof svgNode[1] === 'object',
  )

const toPascalCase = (value: string) =>
  value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')

const resolveHugeIcon = (iconName: string) => {
  const trimmed = iconName.trim()
  const pascal = toPascalCase(trimmed)
  const candidates = [
    trimmed,
    trimmed.endsWith('Icon') ? trimmed : `${trimmed}Icon`,
    pascal,
    pascal.endsWith('Icon') ? pascal : `${pascal}Icon`,
  ] as const

  for (const candidate of candidates) {
    const icon = hugeIcons[candidate as keyof typeof hugeIcons]
    if (icon && isHugeIconDef(icon)) {
      return icon
    }
  }

  return null
}

const toKebabCase = (value: string) => value.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`)

const nodeToPathDef = ([tag, attrs]: SvgNode) => {
  if (tag !== 'path' || typeof attrs.d !== 'string') {
    return null
  }

  const styleEntries = Object.entries(attrs).filter(
    ([key]) => key !== 'd' && key !== 'key' && key !== 'transform',
  )

  const style = styleEntries
    .map(([key, value]) => `${toKebabCase(key)}:${String(value)}`)
    .join(';')

  const transform = attrs.transform !== void 0 ? String(attrs.transform) : ''
  return `${attrs.d}@@${style}@@${transform}`
}

const hugeIconToQuasarSvg = (icon: HugeIconDef) => {
  const pathDefs = icon.map(nodeToPathDef).filter((value): value is string => value !== null)
  return pathDefs.length > 0 ? `${pathDefs.join('&&')}|0 0 24 24` : null
}

export const mapQuasarIconName = (iconName: string) => {
  const hugeIcon = resolveHugeIcon(iconName)
  return hugeIcon ? hugeIconToQuasarSvg(hugeIcon) : null
}
